import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Observable, tap } from 'rxjs';
import { Position } from 'src/app/models/position.model';
import { QuestionCategory } from 'src/app/models/question-category.model';
import { PositionProfileService } from 'src/app/services/position-profile.service';

@Component({
  selector: 'app-position-profiles',
  templateUrl: './position-profiles.component.html',
  styleUrl: './position-profiles.component.scss'
})
export class PositionProfilesComponent implements OnInit, OnChanges {

  public expanded = false;
  public loaded = false;

  public allValid = false;

  @Input()
  public position: Position;

  @ViewChild('panel')
  public panel: MatExpansionPanel;

  @Output()
  public allValidChange = new EventEmitter<boolean>();

  private formValidityMap = new Map<number, boolean>(); // Minden elem érvényességét tárolja

  public items$: Observable<QuestionCategory[]>;

  //public sortProfile = ReportHelper.sortByCategories<PositionProfile>;

  constructor(private service: PositionProfileService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['position'] && changes['position'].currentValue) {
      this.loadData(); // Újratöltjük az adatokat, ha a position változik
    }
  }

  ngOnInit(): void {

  }

  public loadData(): void {
    if (this.position?.id) {
      this.items$ = this.service.getListForCreate(this.position.id).pipe(
        tap(() => {
          this.loaded = true;
        })
      );
    }
  }

  public updateValidity(index: number, isValid: boolean): void {
    this.formValidityMap.set(index, isValid);

    const arr = Array.from(this.formValidityMap.values());
    this.allValid = arr.length == 0 || arr.every(v => v);
    this.allValidChange.emit(this.allValid);
  }

}
